// Three lives, and whether a right answer buys one back.
//
// The rule the app shipped with is simple: three lives, spend them, done. That
// is fine for a player having a good run and punishing for one who is not —
// three early mistakes end a game before it has really started, which for a
// kid is the difference between "again" and "something else".
//
// So it is a setting rather than a redesign. Off, the mode is exactly as it
// was. On, a correct answer regains a life up to the same maximum, which means
// a bad patch is survivable but a bad run still ends: you can only bank back
// what you have already lost.

import { computed } from 'vue';
import { profile } from './profile.js';

export const MAX_LIVES = 3;

/** Does a correct answer buy a life back? Off by default — see note above. */
export const regenLives = computed(() => profile.value.regenLives === true);

/**
 * Call on a CORRECT answer. Capped at MAX_LIVES so it can never bank more than
 * the mode started with, and a no-op when the setting is off.
 *
 * @param {import('vue').Ref<number>} lives
 * @returns {boolean} true when a life was actually regained (for feedback)
 */
export function regainLife(lives) {
  if (!regenLives.value) return false;
  if (lives.value >= MAX_LIVES) return false;
  lives.value += 1;
  return true;
}
